import React from 'react';
import { Building2, X } from 'lucide-react';
import { useTenantView } from '../../context/TenantViewContext';

export function TenantViewBanner() {
  const { viewingTenant, isViewingTenant, exitTenantView } = useTenantView();

  if (!isViewingTenant || !viewingTenant) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-[var(--brand-primary)]/25 bg-[var(--brand-primary)]/8 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex min-w-0 items-start gap-3">
        <span className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-white text-[var(--brand-primary)] shadow-sm">
          <Building2 className="h-4 w-4" aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-900">
            Viewing <span className="text-[var(--brand-primary)]">{viewingTenant.name}</span>
          </p>
          <p className="mt-0.5 text-xs text-slate-600">
            Dashboard data, branding, and AI answers are scoped to this customer.
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={exitTenantView}
        className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 shadow-sm transition duration-150 hover:scale-105 hover:bg-slate-50"
      >
        <X className="h-3.5 w-3.5" aria-hidden="true" />
        Exit to combined view
      </button>
    </div>
  );
}
